import React, { useEffect, useState } from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    CircularProgress
} from '@mui/material';
import { fetchStates } from '../../../../store/api/globalFeeSchedule';
import { State } from '../../../../types/globalFeeScheduleTypes';

interface StateDropdownProps {
    scheduleId: number;
    value: string | null;
    onChange: (value: string) => void;
    onBlur?: () => void;
    error?: string;
    disabled?: boolean;
    required?: boolean;
}

const StateDropdown: React.FC<StateDropdownProps> = ({
    scheduleId,
    value,
    onChange,
    onBlur,
    error,
    disabled = false,
    required = false
}) => {
    const [states, setStates] = useState<State[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (scheduleId) {
            setLoading(true);
            fetchStates(scheduleId)
                .then(data => {
                    setStates(data);
                    setLoading(false);
                })
                .catch(err => {
                    console.error('Error fetching states:', err);
                    setLoading(false);
                });
        }
    }, [scheduleId]);

    return (
        <FormControl fullWidth error={!!error} disabled={disabled || loading} required={required}>
            <InputLabel id="state-select-label">State</InputLabel>
            <Select
                labelId="state-select-label"
                id="state-select"
                value={value || ''}
                label="State"
                onChange={(e) => onChange(e.target.value)}
                onBlur={onBlur}
            >
                <MenuItem value="">
                    <em>Select State</em>
                </MenuItem>
                {loading ? (
                    <MenuItem disabled>
                        <CircularProgress size={20} /> Loading...
                    </MenuItem>
                ) : (
                    states.map((state) => (
                        <MenuItem key={state.code} value={state.code}>
                            {state.name}
                        </MenuItem>
                    ))
                )}
            </Select>
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
};

export default StateDropdown;
